"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiAnalytics {
    static getMaryFirstYearInReview(token) {
        let url = `/analytics/mary/first`;
        return Client_1.default.httpGet(url, token);
    }
    static getMaryYearInReview(token, year) {
        let url = `/analytics/mary/${year}`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiAnalytics;
